import { cn } from '@/utilities/cn'
import React from 'react'
import RichText from '@/components/RichText'
import { Info, AlertTriangle, XCircle, CheckCircle } from 'lucide-react'

export type BannerStyle = 'info' | 'warning' | 'error' | 'success'

export interface BannerProps {
  className?: string
  style?: BannerStyle
  content: any // RichText content
}

const iconMap = {
  info: Info,
  warning: AlertTriangle,
  error: XCircle,
  success: CheckCircle,
}

export const Banner: React.FC<BannerProps> = ({
  className,
  content,
  style = 'info'
}) => {
  const Icon = iconMap[style]

  return (
    <div className={cn('w-full my-6', className)}>
      <div
        className={cn(
          'rounded-lg border-l-4 p-4 shadow-sm flex items-start gap-3',
          {
            'border-ocean-blue bg-ocean-blue/5 text-slate-800': style === 'info',
            'border-amber-500 bg-amber-50 text-amber-900': style === 'warning',
            'border-red-500 bg-red-50 text-red-900': style === 'error',
            'border-sea-green bg-green-50 text-green-900': style === 'success',
          }
        )}
      >
        <Icon
          className={cn('w-5 h-5 flex-shrink-0 mt-0.5', {
            'text-ocean-blue': style === 'info',
            'text-amber-500': style === 'warning',
            'text-red-500': style === 'error',
            'text-sea-green': style === 'success',
          })}
        />
        <div className="flex-1 min-w-0">
          <RichText content={content} enableGutter={false} enableProse={false} />
        </div>
      </div>
    </div>
  )
}